import mime from 'mime-types';
/*---------------------------------------------------------*\
 * LiveFeedVideoController
\*---------------------------------------------------------*/
const deps = {};

class LiveFeedVideoController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($state, $sce, $timeout) {
    deps.$sce = $sce;
    deps.$state = $state;
    deps.$timeout = $timeout;

    this.name = 'liveFeedVideo';
    this.API = null;
  }

  //-----------------------------------
  // Lifecycle
  //-----------------------------------
  $postLink() {
    this.initVideo();
  }


  //-----------------------------------
  // Methods
  //-----------------------------------
  initVideo() {
    deps.$timeout(() => {
      const videoUrl = this.feedConfig.story.videoUrl.slice(0, this.feedConfig.story.videoUrl.indexOf('?'));
      this.config = {
        preload: 'none',
        sources: [
          {
            src: deps.$sce.trustAsResourceUrl(this.feedConfig.story.videoUrl),
            type: mime.lookup(videoUrl)
          }
        ],
        theme: './../../../../assets/videogular/videogular.css'
      };
    });
  }

  onPlayerReady(API) {
    if (API) {
      this.API = API;
      this.API.playsInline = true;
      this.onReady({
        liveFeed: this
      });
      deps.$timeout(() => {
        this.API.play();
      });
    }
  }

  play() {
    if (this.API && this.API.isReady) {
      deps.$timeout(() => {
        this.API.play();
      });
    }
  }

  pause() {
    if (this.API && this.API.isReady) {
      this.API.pause();
    }
  }

  playPause() {
    if (this.API && this.API.isReady) {
      this.API.playPause();
    }
  }

  stop() {
    if (this.API && this.API.isReady) {
      this.API.stop();
    }
  }

  remoteKeydown(e) {
    this.enlargeKeydown({
      event: e
    });
  }
}

LiveFeedVideoController.$inject = [
  '$state',
  '$sce',
  '$timeout'
];

export default LiveFeedVideoController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/liveFeedVideo/liveFeedVideo.controller.js
 **/